export class Image {
    constructor(
        public id: string,
        public name: string,
        public data: string,
        public active: boolean,
        // for student its whole student info
        public extra: { [key: string]: any }
    ) {}
}
